// src/Pages/InsuranceCards.jsx
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaEnvelope, FaPhone, FaWhatsapp, FaGlobe, FaDownload } from "react-icons/fa";

import html2canvas from "html2canvas";
import "swiper/css";
import "swiper/css/pagination";

import goqiiLogo from "../assets/goqii-logo.png";
import partner from "../assets/partner.png";
import kotak from "../assets/Kotak.png"
import zKotak from "../assets/zkotak.png"
import { getUrlParams } from "../apiService/timespam";
import GOQiiButton from "../Components/GoqiiButton";
import "./InsuranceCards.css";
import { lifestyleApi } from "../apiService/api";

const InsuranceCards = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const { encryptedId } = getUrlParams();
    if (!encryptedId) return;

    lifestyleApi
      .getUserInsurnceDetails(encryptedId)
      .then((response) => {
        setData(response.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load.");
        setLoading(false);
      });
  }, []);

  // 🔥 SKELETON LOADING

  const downloadECard = () => {
    const card = document.querySelector(".ecard-download-target");
    if (!card) {
      console.error("E-card element not found");
      alert("Error: Could not find e-card to download");
      return;
    }

    html2canvas(card, {
      scale: 2,
      logging: false,
      useCORS: true,
      allowTaint: true,
      backgroundColor: null, // transparent, so the rounded corners don't export as white
      ignoreElements: (el) => el.classList?.contains("download-btn"),
    }).then((canvas) => {
      const link = document.createElement("a");
      link.download = "GOQii_Insurance_ECard.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    }).catch((err) => {
      console.error("Download failed:", err);
      alert("Failed to download e-card");
    });
  };
  if (loading) {
    return (
      <section className="insurance-homeCard">
        <div className="container-ins">
          <div className="swiper-wrapper-ins">
            {[1].map((v) => (
              <div key={v} className="ins-skel-card">
                <div className="ins-skel-row">
                  <div className="shimmer skel-badge"></div>
                  <div className="shimmer skel-name"></div>
                  <div className="shimmer skel-chip"></div>
                </div>

                <div className="ins-skel-row" style={{ justifyContent: "space-between" }}>
                  <div className="shimmer skel-mid-box"></div>
                  <div className="shimmer skel-mid-box"></div>
                </div>

                <div className="ins-skel-row">
                  <div className="shimmer skel-info"></div>
                  <div className="shimmer skel-btn"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (error || !data) {
    return <div className="ins-error">{error || "No data found."}</div>;
  }

  // ------- mapping your JSON -------------
  const user = data || {};

  const {
    firstName = "",
    lastName = "",
    dob = "",
    gender = "",
    memberId = "",
    insuranceEndDate = "",
    corporatePolicyNo = "",
    platform = "",
    healthInsuranceAmount = "0",
    lifeInsuranceAmount = "0",
    msg = "Be Elite and get upto 5 lakh health cover",
    showInsSection = false,
    detailLink = "",
    policyPdf = "",
    whatsappSent = "",
    emailSent = "",
    proposalNum = "",
    policyKotakNo = "",
  } = user;

  const platformLower = platform.toLowerCase();
  const isKotak = platformLower === "kotak" || platformLower === "z_kotak";
  const isCare = platformLower === "care";
  // e-card extras: kotak shows UHID + policy no, z_kotak shows policy no only
  const showUhid = platformLower === "kotak" && proposalNum;
  const showKotakPolicyNo = isKotak && policyKotakNo;
  const partnerLogo =
    isCare
      ? partner
      : platformLower === "z_kotak"
        ? zKotak
        : kotak;
  const knowMoreUrl = detailLink;
  const whatsappUrl = whatsappSent;
  const emailSentUrl = emailSent;

  return (
    <section className="insurance-homeCard">
      <div className="container-ins">
        <div className="swiper-wrapper-ins">
          <Swiper slidesPerView={"auto"} spaceBetween={10}>
            {/* -------- CARD 1 (white) ---------- */}
            <SwiperSlide className="insuranceCard">
              <div className="card-inner">
                <div className="row-top">
                  <div className="badge-wrapper">
                    <img
                      src="https://appcdn.goqii.com/storeimg/21490_1764323489.png"
                      alt="badge"
                    />
                  </div>

                  <div className="name-wrapper">
                    <h1 className="title">
                      {firstName}
                      {firstName && " "}
                      {lastName}
                    </h1>
                    <span className="covered-chip">You’re Covered</span>
                  </div>

                  {corporatePolicyNo && Number(corporatePolicyNo) > 0 && (
                    <div className="policy-wrapper">
                      <p className="subtext">{t("insurance.policyNumber")}</p>
                      <p className="policy-number">{corporatePolicyNo}</p>
                    </div>
                  )}
                </div>

                <div className="row-middle">
                  <div className="col-half">
                    <p className="subtext">{t("insurance.health")}</p>
                    <p className="price">
                      ₹ {healthInsuranceAmount}
                      <sup>*</sup>
                    </p>
                  </div>


                </div>

                <div className="row-bottom">
                {msg && (
                  <>
                    <div className="info-icon">
                      <img
                        src="https://appcdn.goqii.com/storeimg/95901_1764323553.png"
                        alt="info"
                      />
                    </div>
                    <p className="info-text">{msg}</p>
                  </>
                  )}

                  {detailLink && (
                    <div className="btn-wrapper">
                      <GOQiiButton
                        text={t("insurance.viewMore")}
                        size="small"
                        color="green"
                        solid={true}
                        shape="rounded_edges"
                        onClick={() => {
                          window.location.href = knowMoreUrl;
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </SwiperSlide>

            {/* -------- CARD 2 (blue – e-card) ---------- */}
            <SwiperSlide className="insuranceCard-blue">
              <div className="card-inner ecard-download-target">
                <div className="row-top blue-top-row">
                  <div className="goqii-logo">
                    <img src={goqiiLogo} alt="GOQii" />
                  </div>
                  <div style={{ fontSize: "12px" }}>{t("insurance.insuranceCover")}</div>
                  <div className={`partner-logo${platformLower === "z_kotak" ? " light-bg" : ""}`}>
                    <img src={partnerLogo} alt="partner" />
                  </div>
                </div>

                <div className="row-blue-content">
                  <p className="blue-text">
                    <span>Name&nbsp; </span>
                    {firstName} {lastName}
                  </p>
                  <div className="row-blue-two-col">
                    <p className="blue-text">
                      <span>DOB&nbsp; </span>
                      {dob}
                    </p>
                    <p className="blue-text">
                      <span>Gender&nbsp; </span>
                      {gender && gender[0].toUpperCase() + gender.slice(1)}
                    </p>
                  </div>

                  {showUhid && (
                    <p className="blue-text blue-row">
                      <span>UHID&nbsp; </span>
                      {proposalNum}
                    </p>
                  )}
                  {showKotakPolicyNo && (
                    <p className="blue-text blue-row">
                      <span>{t("insurance.policyNumber")}&nbsp; </span>
                      {policyKotakNo}
                    </p>
                  )}

                  <div className="row-blue-two-col bottom">
                    <div>
                      <p className="blue-text">
                        <span>{t("insurance.memberId")}</span>
                      </p>
                      <p className="blue-text">{memberId}</p>
                    </div>
                    <div>
                      <p className="blue-text">
                        <span>{t("insurance.validTill")}</span>
                      </p>
                      <p className="blue-text">{insuranceEndDate}</p>
                    </div>
                  </div>
                </div>
                {/* EYE / DOWNLOAD ICON — when policyPdf exists, and always for Care
                    (Care responses don't send policyPdf; the download is a screenshot of this card) */}
                {(policyPdf || isCare) && (
                  <button
                    className="download-btn"
                    aria-label="Download e-card"
                    onClick={() => downloadECard()}
                  >
                    <FaDownload aria-hidden="true" />
                  </button>
                )}
              </div>
            </SwiperSlide>

            {/* -------- CARD 3 (blue – contact / disclaimer) ---------- */}
            <SwiperSlide className="insuranceCard-blue">
              <div className="card-inner">
                <div className="row-contact">
                  <p className="subtitle">
                    {isKotak ? (
                      <>
                        <FaEnvelope aria-hidden="true" />{" "}
                        <span>
                          <a
                            href={emailSent}
                            target="_blank"
                            rel="noreferrer"
                          >
                            care@kotak.com
                          </a>
                        </span>
                      </>
                    ) : (
                      <>
                        <FaGlobe aria-hidden="true" />{" "}
                        <a
                          href="https://www.careinsurance.com/contact-us.html"
                          target="_blank"
                          rel="noreferrer"
                        >
                          www.careinsurance.com/contact-us.html
                        </a>
                      </>
                    )}
                  </p>

                  <p className="subtitle">
                    {isKotak ? (
                      <a
                        href={whatsappUrl}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FaPhone aria-hidden="true" /> Toll
                        free: <span>1800 2664545</span>
                      </a>
                    ) : (
                      <a
                        href={whatsappUrl}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FaWhatsapp aria-hidden="true" />
                        <span> 8860402452</span>
                      </a>
                    )}
                  </p>
                </div>

                <div className="row-contact-bottom">
                  {isKotak ? (
                    <>
                      <p className="subtitle">Address:</p>
                      <p className="subtitle">
                        Family Health Plan (TPA) Limited, Gr. Floor, Srinilaya
                        Cyber, Spazio, Road No. 2, Banjara Hills, Hyderabad,
                        Telangana - 500034.
                      </p>
                    </>
                  ) : (
                    <>
                      <p className="subtitle">{t("insurance.disclaimer")}</p>
                      <p className="subtitle">
                        This card is non-transferable and subject to policy
                        terms. For cashless facility, present this card with
                        photo ID. Valid until policy end or cancellation.
                      </p>
                    </>
                  )}
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>

      {/* bottom SAFE table section */}
      {showInsSection && (
        <section className="Insurance-section">
          <div className="info-card">
            <h5>{t("insurance.upgrade.title")}</h5>
            <p>
              SAFE stands for Sedentary, Active, Fit and Elite which are
              different stages of your health journey with GOQii.
            </p>
            <p>
              GOQii's SAFE Lifestyle is a way to transform your life by taking
              simple actions which lead to behavioural change. Your goal in this
              journey is to take small actions and upgrade lifestyle.
            </p>
            <p>Upgrade your health insurance cover by living a healthy lifestyle.</p>

            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>GOQii SAFE SCORE</th>
                    <th>ELIGIBLE INSURANCE COVER</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <img
                        src="https://appcdn.goqii.com/storeimg/14412_1660300720.png"
                        alt=""
                        className="icon-img"
                      />
                    </td>
                    <td>
                      Up to <b>1 {t("insurance.lakh")}</b> Health Insurance + <br />1 {t("insurance.lakh")} Life
                      Insurance Cover
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        src="https://appcdn.goqii.com/storeimg/25670_1660301760.png"
                        alt=""
                        className="icon-img"
                      />
                    </td>
                    <td>
                      Up to <b>2 {t("insurance.lakh")}</b> Health Insurance + <br />1 {t("insurance.lakh")} Life
                      Insurance Cover
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        src="https://appcdn.goqii.com/storeimg/84166_1660301776.png"
                        alt=""
                        className="icon-img"
                      />
                    </td>
                    <td>
                      Up to <b>3 {t("insurance.lakh")}</b> Health Insurance + <br />1 {t("insurance.lakh")} Life
                      Insurance Cover
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        src="https://appcdn.goqii.com/storeimg/60762_1660301791.png"
                        alt=""
                        className="icon-img"
                      />
                    </td>
                    <td>
                      Up to <b>5 {t("insurance.lakh")}</b> Health Insurance + <br />1 {t("insurance.lakh")} Life
                      Insurance Cover
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      )}
    </section>
  );
};

export default InsuranceCards;